import { NgModule } from '@angular/core'
import { CustomLinkDirective } from './custom-link.directive'

@NgModule({
  declarations: [CustomLinkDirective],
  exports: [CustomLinkDirective]
})
export class CustomLinkModule {}
